// Usage: This Block is made to be used with the Headlines
// Richtext etc, so we can align the text accordingly

import * as React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

export default function TextWrapper({ blok }) {
  if (!blok.blocks.length) {
    return null;
  }

  return (
    <div className={blok.text_align} {...storyblokEditable(blok)}>
      {blok?.blocks.map((block) => (
        <StoryblokComponent blok={block} key={block._uid} />
      ))}
    </div>
  );
}
